import { CenterItem } from '@components/LinearLayout';
import { styled } from 'styled-components';

export const PartnerItemRoot = styled(CenterItem)<{
  $lightMode?: boolean;
  $partnerMode?: boolean;
  $noBorder?: boolean;
  $borderRadius?: string;
  $width?: string;
  $height?: string;
}>`
  overflow: hidden;
  position: relative;

  background-color: ${({ theme }) => theme.color.white};
  border-radius: ${({ $borderRadius, theme }) =>
    $borderRadius || theme.borderRadius.radius10};
  border: ${({ $noBorder, theme }) =>
    $noBorder ? 'none' : `0.2rem solid ${theme.color.strokeGrey}`};

  width: ${({ $lightMode, $partnerMode }) =>
    $partnerMode
      ? `min(24.3rem, 100%)`
      : $lightMode
        ? `min(25.5rem, 100%)`
        : `min(27.3rem, 100%)`};
  height: ${({ $partnerMode }) => ($partnerMode ? `11.5rem` : '13.6rem')};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: min(15.6rem, 100%);
    width: ${({ $width }) => $width};
    height: fit-content;
    margin: auto;
    height: ${({ $height }) => $height};
  }
  &:hover {
    cursor: pointer;
  }
`;

export const BackgroundImageOverlay = styled.div<{ $isHovered: boolean }>`
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  ${({ $isHovered, theme }) =>
    $isHovered
      ? `opacity: 0.5 ; mix-blend-mode: multiply; background: ${theme.color.mobilityGrey3};   transition: all 0.2s linear; `
      : `background: ${theme.color.transparent};   transition: all 0.3s linear;`}
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.color.white};
  padding: 0 1rem;
`;

export const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: fill;
`;
